/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Company_NameInputs */

const vi_einvoice_buyer_company_name = /** @type {(inputs: Einvoice_Buyer_Company_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đơn vị`)
};

/**

* @param {Einvoice_Buyer_Company_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_company_name = /** @type {((inputs?: Einvoice_Buyer_Company_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Company_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_company_name(inputs)
});